import { Routes, Route, Navigate } from 'react-router-dom'

import MaintenanceList from 'Presentation/Views/Maintenance/List/View'
import { MaintenanceListViewContextProvider } from 'Presentation/Views/Maintenance/List/Context'
import { MaintenanceFormModalContextProvider } from 'Presentation/Views/Maintenance/Form/Context'

import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const MaintenanceRoutes = () => (
  <MaintenanceFormModalContextProvider>
    <MaintenanceListViewContextProvider>
      <Routes>
        <Route element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.maintenance} />}>
          {/* Route: Maintenance List */}
          <Route index element={<MaintenanceList />} />
          {/* Route: Maintenance List */}

          <Route path='*' element={<Navigate to='/home' />} />
        </Route>
      </Routes>
    </MaintenanceListViewContextProvider>
  </MaintenanceFormModalContextProvider>
)

export default MaintenanceRoutes
